import { handleActions } from 'redux-actions'
import * as actions from '@/store/action/ticket/'
import { initStateData, createInitTicketState, initTicketData } from "@/store/action/ticket/propsType";
import { REPLY_TYPE, ADD_ATTACH_TYPE, DEL_ATTACH_TYPE, INTERNAL_KEY } from '@/containers/ticket/components/replyArea/replyInfo/config'
import { TICKET_INFO_DATA_SORT, ORDER_INFO_DATA_SORT } from './dataSort'
import { LAST_TICKET_TAB_NUMBER } from '@/utils/const'
import { message } from 'antd'
import { i18nTranslate } from "@didi/i18n-plugin"
import omega from '@/utils/omega.js'
let addNum = 0
// tabs 相关store
const ticketReducer = handleActions({
    [actions.resetFetchState]: (state, action) => ({
        ...state,
        ...action.payload
    }),
    [actions.addPageTabs]: (state, action) => {
        let { ticketInfoList } = state
        // 展开带有id的页卡时判断是否时，判断次id页卡是否存在，如果存在则
        let { id, handle } = action.payload || {}
        if (id) {
            // 获取关闭页卡索引
            let idx = null
            ticketInfoList.forEach((re, i) => {
                if (re.id === id) {
                    idx = i;
                }
            })
            if (idx !== null) {
                // 包含
                return {
                    ...state,
                    ticketActivity: idx
                }
            }
            // 新版工单页编辑页展示
            omega.trackEvent('ibt_cs_ticket_system_editticketpage_sw',{});
        } else {
            // 新版工单页新增页展示
            omega.trackEvent('ibt_cs_ticket_system_addticketpage_sw', {})
        }

        // 新版工单页处理页展示
        omega.trackEvent('ibt_cs_ticket_system_ticketdetails_sw', {})

        // 当页卡数超过最大限额时,提示错误信息
        let ticketLen = ticketInfoList.length
        if (ticketLen >= LAST_TICKET_TAB_NUMBER) {
            message.warn(i18nTranslate("CS_info_This_page_Cpww"))
            return {
                ...state
            }
        }

        // 新增逻辑
        let newTicketInfo = { ...initTicketData, ...action.payload, ...{ timeStamp: String(new Date().getTime()) + String(addNum), id: id ? id : '', handle } }

        ticketInfoList.push(newTicketInfo)
        ticketInfoList[0].closable = false
        addNum++
        return {
            ...state,
            ticketInfoList,
            ticketActivity: ticketInfoList.length - 1
        }
    },
    [actions.toggleTicketActivity]: (state, action) => ({
        ...state,
        ticketActivity: action.payload.ticketActivity
    }),
    [actions.delPageTabs]: (state, action) => {
        let { targetKey } = action.payload
        let { ticketInfoList, ticketActivity } = state
        let newActiveKey = ticketInfoList[ticketActivity]?.timeStamp;
        let lastIndex;
        let newTicketActivity = ticketActivity

        ticketInfoList.forEach((pane, i) => {
            if (pane.timeStamp === newActiveKey) {
                lastIndex = i - 1;
            }
        })

        if (ticketInfoList.length && newActiveKey === targetKey) {
            if (lastIndex >= 0) {
                newTicketActivity = lastIndex
            } else {
                newTicketActivity = 0
            }
        }

        if (newActiveKey === targetKey) {
            newTicketActivity = 0
        }

        const newTicketInfoList = ticketInfoList.filter(pane => pane.timeStamp !== targetKey);
        return {
            ...state,
            ticketInfoList: newTicketInfoList,
            ticketActivity: newTicketActivity
        }
    },
    [actions.updateTicketData]: (state, action) => {
        let { ticketInfoList, ticketActivity } = state
        let ticketInfoListInfo = [...ticketInfoList]
        // 获取工单索引
        let {id} = action.payload
        let idx = ticketActivity
        if(id){
            ticketInfoList.forEach((re, i) => {
                if (re.id === id) {
                    idx = i;
                }
            })
        }
        ticketInfoListInfo[idx] = { ...ticketInfoList[idx], ...action.payload }
        return {
            ...state,
            ticketInfoList: ticketInfoListInfo
        }
    },
}, initStateData)

export default ticketReducer

// 子store ticket reducer
export const createTicketReducer = handleActions({
    // 是否展示注册用户提示文案
    [actions.isShowUserTips]: (state, action) => {
        return {
            ...state,
            isShowUserTips: action.payload,
        }
    },
    // 是否展示回复弹窗
    [actions.isSingeReplyShow]: (state, action) => {
        return {
            ...state,
            isSingeReplyShow: action.payload,
        }
    },
    // 判断是否是第一次点击流转、关闭、已解决
    [actions.isFirstCloseAndResolved]: (state, action) => {
        return {
            ...state,
            isFirstCloseAndResolved: action.payload,
        }
    },
    // 是否预绑定工单
    [actions.isPreBind]: (state, action) => {
        return {
            ...state,
            isPreBind: action.payload,
        }
    },
    // 更新ticketID
    [actions.updataTicketId]: (state, action) => {
        return {
            ...state,
            id: action.payload,
        }
    },
    // generateIdSuccess
    [actions.generateIdSuccess]: (state, action) => {
        return {
            ...state,
            id: action.payload && action.payload.id
        }
    },

    //获取当前utc时间  getUtcTimeSuccess
    [actions.getUtcTimeSuccess]: (state, action) => {
        return {
            ...state,
            utcActionStartTime: action.payload
        }
    },

    // 更新工单 处理状态
    [actions.handleTicket]: (state, action) => {
        return {
            ...state,
            status: action.payload.status,
        }
    },

    // ticketInfo 
    [actions.setTicketInfoSuccess]: (state, action) => {
        return TICKET_INFO_DATA_SORT(state, action)
    },
    [actions.setTicketRequesterItem]: (state, action) => {
        let { requester } = state
        let { payload } = action
        return {
            ...state,
            requester: { ...requester, ...payload }
        }
    },
    // setTicketComplaintItem
    [actions.setTicketComplaintItem]: (state, action) => {
        const currentComplaintInfo = {
            ...state.complaint,
            ...action.payload
        }
        return {
            ...state,
            complaint: currentComplaintInfo
        }
    },
    [actions.setTicketItem]: (state, action) => {
        const currentTicketInfo = {
            ...state.ticket,
            ...action.payload
        }
        return {
            ...state,
            ticket: currentTicketInfo
        }
    },

    // 更新工单页 info order 参数
    [actions.setTicketOrderItem]: (state, action) => {
        const currentData = {
            ...state.order,
            ...action.payload
        }
        return {
            ...state,
            order: currentData
        }
    },

    [actions.setTicketDataItem]: (state, action) => {
        const currentData = {
            ...state.data,
            ...action.payload
        }
        return {
            ...state,
            data: currentData
        }
    },

    [actions.setTicketSopItem]: (state, action) => {
        const currentSop = {
            ...state.sop,
            ...action.payload
        }
        return {
            ...state,
            sop: currentSop
        }
    },

    [actions.setTicketTagInfo]: (state, action) => {
        const currentTag = [
            ...action.payload
        ]
        return {
            ...state,
            tag: currentTag
        }
    },

    [actions.setTicketTagList]: (state, action) => {
        const currentTag = [
            ...action.payload
        ]
        return {
            ...state,
            tagList: currentTag
        }
    },


    [actions.setBusinessTypeList]: (state, action) => {
        const currentTag = [
            ...action.payload
        ]
        return {
            ...state,
            businessList: currentTag
        }
    },

    [actions.formCheckSuccess]: (state) => {
        return {
            ...state,
            formCheck: state.formCheck + 1,
        }
    },
    // 订单点击验证 手机号、用户类型
    [actions.orderFormCheckSuccess]: (state) => {
        let order = { ...state.order }
        let orderFormCheck = state.order.orderFormCheck ? state.order.orderFormCheck : 0
        order.orderFormCheck = orderFormCheck + 1
        return {
            ...state,
            order,
        }
    },

    //订单卡片点击订单号，展示订单页卡
    [actions.relateTicketInfo]: (state) => {
        let order = { ...state.order }
        let relateTicket = state.order.relateTicket ? state.order.relateTicket : 0
        order.relateTicket = relateTicket + 1
        return {
            ...state,
            order,
        }
    },

    [actions.getOrderListSuccess]: (state, action) => {
        let { total, data } = action.payload.data?.data ? action.payload.data : { total: 0, data: [] }
        let newlist = state.data?.orderList?.list || []
        const currentData = {
            ...state.data,
            orderList: {
                list: [...newlist, ...data],
                total
            }
        }
        return {
            ...state,
            data: currentData
        }
    },
    // 设置订单详情数据
    [actions.setTicketInfoOrderDetails]: (state, action) => {
        let Obj = state.data?.orderDetails
        const currentData = {
            ...state.data,
            orderDetails: { ...Obj, ...action.payload }
        }
        return {
            ...state,
            data: currentData
        }
    },

    // 清空订单详情数据
    [actions.clearTicketInfoOrderDetails]: (state, action) => {
        const currentData = {
            ...state.data,
            orderDetails: {},
        }
        return {
            ...state,
            data: currentData,
            complaint: {}
        }
    },

    // 通过订单id获取订单详情页面
    [actions.getOrderinfoSuccess]: (state, action) => {
        return ORDER_INFO_DATA_SORT(state, action)
    },
    // 重置 OrderList
    [actions.clearOrderList]: (state) => {
        const currentData = {
            ...state.data,
            orderList: {
                list: null,
                total: 0
            }
        }
        return {
            ...state,
            data: currentData
        }
    },

    // 设置回复区数据
    [actions.setTickeReplyInfo]: (state, action) => {
        let { replyType, key, value } = action.payload
        let newReply = { ...state.reply }
        let replyTypeList = state.reply[REPLY_TYPE[replyType].storeName] ? state.reply[REPLY_TYPE[replyType].storeName] : {}
        replyTypeList[key] = value
        newReply[REPLY_TYPE[replyType].storeName] = replyTypeList
        return {
            ...state,
            reply: newReply
        }
    },

    // 设置editorHeight
    [actions.setEditorHeight]: (state, action) => {
        let { editorHeight } = action.payload
        let newReply = { ...state.reply }
        newReply.editorHeight = editorHeight
        return {
            ...state,
            reply: newReply
        }
    },

    // 设置回复区数据
    [actions.setTickeReplyActivity]: (state, action) => {
        let { activity } = action.payload
        let newReply = { ...state.reply }
        newReply.activity = activity
        return {
            ...state,
            reply: newReply
        }
    },

    // 更新工单页 reply 回复区附件信息
    [actions.setReplyAttachInfo]: (state, action) => {
        let { replyType, key, value } = action.payload
        // let newReply = { ...state.reply }
        let newReply = { ...state.reply }
        let getReplyTypeList = newReply[REPLY_TYPE[replyType].storeName]
        if (key === ADD_ATTACH_TYPE) {
            // 新增附件
            // 组装附件结构
            let attachKeysArr = getReplyTypeList?.attachKeys ? getReplyTypeList?.attachKeys : []
            attachKeysArr.push(value)

            let replyTypeList = getReplyTypeList ? getReplyTypeList : {}
            replyTypeList.attachKeys = attachKeysArr
            newReply[REPLY_TYPE[replyType].storeName] = replyTypeList
        }
        if (key === DEL_ATTACH_TYPE) {
            // 删除附件
            let getAttachKeys = getReplyTypeList.attachKeys.filter(item => item !== value)
            newReply[REPLY_TYPE[replyType].storeName].attachKeys = getAttachKeys
        }
        return {
            ...state,
            reply: newReply
        }
    },

    // 清除回复区数据
    [actions.clearTickeReplyData]: (state, action) => {
        // let { activity } = state.reply
        return {
            ...state,
            reply: {
                internal: { attachKeys: [] }, // 内部留言
                mail: { attachKeys: [] }, // 邮件
                transfer: { attachKeys: [] }, // 流转
                inApp: { attachKeys: [] }, // 异步消息
                isClear: true,
                activity: INTERNAL_KEY
            }
        }
    },

    // 清除回复区数据成功
    [actions.clearTickeReplyDataSuccess]: (state, action) => {
        let { activity } = state.reply
        return {
            ...state,
            reply: {
                internal: { attachKeys: [] }, // 内部留言
                mail: { attachKeys: [] }, // 邮件
                transfer: { attachKeys: [] }, // 流转
                inApp: { attachKeys: [] }, // 异步消息
                isClear: false,
                activity
            }
        }
    },
}, createInitTicketState())
